import { CommonModel } from '../../base-data/area-building/model/common-model.interface';
import { FormItem } from '../../base-data/area-building/model/form-item-interface';


export const BASE_DATA_ITEMS: FormItem[] = [
  { text: 'DetailInfo.AppEmplid', value: 'emplid' },
  { text: 'DetailInfo.AppPhone', value: 'phone' },
  { text: 'DetailInfo.DocNo', value: 'formId' },
  { text: 'DetailInfo.AppDate', value: 'applayTime' },
  { text: 'AreaBuilding.Park', value: 'garden' },
  { text: 'AreaBuilding.Area', value: 'area' },
  { text: 'AreaBuilding.Building', value: 'building' },
  { text: 'AreaBuilding.Floor', value: 'floor' },
  { text: 'AreaBuilding.FunctionRoom', value: 'functionRoom' },
  { text: 'AreaBuilding.RoomNumber', value: 'roomNumber' },
  { text: 'DetailInfo.CIVIL', value: 'civilEngineering' },
  { text: 'DetailInfo.ELECTRO', value: 'electromechanical' },
  { text: 'DocApp.DemandsDescription', value: 'description' },
  { text: 'DocApp.OnSitePhoto', value: 'image' },
  { text: 'DocApp.UploadDemandsPlan', value: 'requireDocs' }
];


export const BASE_DATA_FORM: CommonModel = {
  emplid: '',
  phone: '',
  formId: '',
  applicantId:'',
  applayTime: '',
  garden: '',
  area: '',
  building: '',
  floor: '',
  functionRoom: '',
  roomNumber: '',
  civilEngineering: 0,
  electromechanical: 0,
  description: '',
  image: '',
  requireDocs: '',
  version:''
}

export const EDICT_DATA_FORM: CommonModel = {
  civilEngineering: 0,
  electromechanical: 0,
  description: '',
  image: [],
  requireDocs: []
}
